import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FlaskConical, Check, X } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const fr = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("fr-FR", { day: "numeric", month: "long" });

export function OptionTrialsCard() {
  const { user, refresh } = useAuth();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState("");
  useEffect(() => { http.get("/company/option-trials").then((r) => { setItems(r.data); if (r.data.length && window.location.search.includes("tab=options")) setTimeout(() => document.getElementById("options")?.scrollIntoView({ behavior: "smooth" }), 100); }).catch(() => {}); }, []);
  if (!items.length) return null;
  const decide = async (code, keep) => {
    if (!keep && !window.confirm("Arrêter cette option maintenant ? Elle sera désactivée tout de suite.")) return;
    setBusy(code);
    try { const r = await http.post(`/company/option-trials/${code}`, { keep }); setItems(r.data); refresh(); toast.success(keep ? "Option conservée : elle sera facturée à la prochaine échéance" : "Option arrêtée"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(""); }
  };
  return (
    <div id="options" className="border border-amber-200 bg-amber-50/50 rounded-md p-6 mb-6" data-testid="option-trials-card">
      <div className="flex items-center gap-2 mb-1"><FlaskConical className="h-5 w-5 text-amber-600" /><h2 className="font-display text-xl font-bold">Options à l'essai</h2></div>
      <p className="text-sm text-slate-600 mb-4">Essai gratuit de 15 jours. Sans réponse de votre part, l'option s'arrête automatiquement à la fin de l'essai, sans frais.</p>
      <div className="space-y-2">
        {items.map((t) => (
          <div key={t.code} className="flex flex-wrap items-center gap-3 bg-white border border-slate-200 rounded-md px-4 py-3" data-testid={`option-trial-${t.code}`}>
            <div className="flex-1 min-w-[200px]">
              <div className="font-semibold">{t.label}</div>
              <div className="text-xs text-slate-500">
                {t.choice === "keep" ? "Conservée — facturée à partir de la prochaine échéance" : t.choice === "stop" ? "Arrêtée" : `Gratuit jusqu'au ${fr(t.trial_until)} inclus`}
                {t.price > 0 && !t.choice && ` · ensuite ${t.price.toLocaleString("fr-FR", { style: "currency", currency: "EUR" })} HT / mois`}
              </div>
            </div>
            {!t.choice && t.active && user?.role === "admin" && <>
              <button disabled={busy === t.code} onClick={() => decide(t.code, true)} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-semibold disabled:opacity-50 transition-colors" data-testid={`option-trial-keep-${t.code}`}><Check className="h-4 w-4" />Garder</button>
              <button disabled={busy === t.code} onClick={() => decide(t.code, false)} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-slate-300 hover:bg-slate-50 text-sm font-semibold disabled:opacity-50 transition-colors" data-testid={`option-trial-stop-${t.code}`}><X className="h-4 w-4" />Arrêter</button>
            </>}
            {t.choice && <span className={`text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full ${t.choice === "keep" ? "bg-emerald-100 text-emerald-800" : "bg-slate-100 text-slate-600"}`} data-testid={`option-trial-status-${t.code}`}>{t.choice === "keep" ? "Gardée" : "Arrêtée"}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
